import { useState } from "react";
import { Check, ArrowRight } from "lucide-react";
import { Section } from "./Section";
import { RADialog } from "./RADialog";

const LISTINGS = [
  ["Intraday Index Options", "NIFTY & BANKNIFTY weekly", "Momentum · 3–5 signals a week", "High-liquidity index-option setups with defined stops, published intraday with live position tracking."],
  ["Positional Equity Momentum", "NSE cash, F&O lot stocks", "Swing · 15–40 day holds", "Relative-strength leaders above rising long-term averages, with staged exits and a portfolio-level stop."],
  ["Options Income Overlay", "Monthly expiry, hedged", "Income · hedged premiums", "Hedged premium-selling structures with strike selection, adjustment rules and capital-allocation guidance."],
];

const RA_POINTS = [
  "Publisher's SEBI Research Analyst registration is shown on every listing",
  "Live track record attached to the strategy — updated as trades happen",
  "No assured-return claims: strategies publish risk, drawdown and allocation guidance",
  "Billing, access control and grievance handling run through Trading Nifty",
];

export const Marketplace = () => {
  const [open, setOpen] = useState(false);
  return (
    <Section id="marketplace" alt testId="marketplace-section" eyebrow="Strategy marketplace" title="Buy strategies from SEBI-registered research analysts"
      intro="A curated shelf instead of a Telegram swarm. Only SEBI-registered Research Analysts can publish paid strategies here — and their identity, registration and live performance travel with every strategy.">
      <div className="grid lg:grid-cols-4 gap-5">
        {LISTINGS.map(([t, m, s, d], i) => (
          <article key={t} className="tn-card tn-reveal p-6 bg-[var(--tn-bg)] flex flex-col" style={{ transitionDelay: `${i * 80}ms` }} data-testid={`marketplace-listing-${i}`}>
            <h3 className="font-display font-medium text-lg">{t}</h3>
            <p className="font-mono text-[11px] text-[var(--tn-cyan)] mt-2">{m}</p>
            <p className="font-mono text-[11px] text-[var(--tn-muted)] mt-1">{s}</p>
            <p className="text-sm text-[var(--tn-muted)] mt-4 leading-relaxed flex-1">{d}</p>
            <p className="font-mono text-[10px] uppercase tracking-wider text-[var(--tn-muted)] border-t border-[var(--tn-line)] pt-4 mt-5">Sample listing · live at launch</p>
          </article>
        ))}
        <aside className="tn-reveal rounded-xl border border-[rgba(34,211,238,0.35)] bg-[rgba(34,211,238,0.05)] p-6 flex flex-col" data-testid="marketplace-ra-box">
          <h3 className="font-display font-medium text-lg">Publishing as an RA?</h3>
          <ul className="space-y-3 mt-4 flex-1">
            {RA_POINTS.map((p) => (
              <li key={p} className="flex gap-2 text-sm text-[var(--tn-muted)]"><Check size={15} className="text-[var(--tn-cyan)] shrink-0 mt-0.5" />{p}</li>
            ))}
          </ul>
          <button onClick={() => setOpen(true)} className="tn-btn mt-6" data-testid="become-ra-partner-btn">Become an RA partner <ArrowRight size={16} /></button>
        </aside>
      </div>
      <RADialog open={open} onOpenChange={setOpen} />
    </Section>
  );
};
